import {shape, string, number, oneOfType, bool} from 'prop-types';

export default shape({
  overSpeed: oneOfType([string, number]),
  excessiveOverSpeed: oneOfType([string, number]),
  gpsSpeed: bool
});
